import { defineComponent, ref, watch, reactive, computed } from "vue";
import tagTascader from "@/views/repository/labels/components/tag-cascader.vue";
import { definePropType } from "@types-vue/props";
import store from "@/store";
import { TabsType } from "../config/enums";
import { publicOptions, statusOptions, showStatusOption, copyrightOptions, applicableOptions, videoApplicableOptions } from "../config/option";
export default defineComponent({
    name: "update-dialog",
    components: {
        tagTascader: tagTascader
    },
    props: {
        operationType: {
            type: definePropType(String),
            default: ""
        }
    },
    setup: function setup(props) {
        var publicRadio = ref(1);
        var statusRadio = ref(2);
        var copyrightRadio = ref(1);
        var checkedTool = ref([]);
        var audit_status = ref("approved");
        var remark = ref("");
        var isIndeterminate = ref(false);
        var checkAll = ref(false);
        var tagCascaderRef = ref();
        var resource = computed(function() {
            return store.state.resource;
        });
        var tagTitle = computed(function() {
            if (props.operationType === "addLabel") {
                return "\u6DFB\u52A0\u6807\u7B7E:";
            } else if (props.operationType === "deLabel") {
                return "\u79FB\u9664\u6807\u7B7E:";
            }
            return "\u4FEE\u6539\u6807\u7B7E:";
        });
        var showStatusOptions = computed(function() {
            if (resource.value.activeTab === TabsType.FRAGMENT) {
                return showStatusOption;
            }
            return statusOptions;
        });
        // 应用范围
        var allApplicableOptions = computed(function() {
            if ([
                TabsType.FLOWERWORD,
                TabsType.FILTER,
                TabsType.TRANSITION,
                TabsType.ANIMATION, 
            ].indexOf(resource.value.activeTab) !== -1) {
                return videoApplicableOptions;
            } else if ([
                TabsType.PRESETS,
                TabsType.MODEL,
                TabsType.ACTION
            ].indexOf(resource.value.activeTab) !== -1) {
                return applicableOptions.filter(function(t) {
                    return t.value === 1;
                });
            }
            return applicableOptions;
        });
        var tagConfig = reactive({
            isMultiple: true,
            isRefresh: false,
            treeParams: {
                group_type: 4,
                asset_type: 0
            }
        });
        var handlUpdateChange = function(value) {
            resource.value.dialogFormInfo.value = String(value);
        };
        var handleCheckedToolChange = function(value) {
            var checkedCount = value.length;
            checkAll.value = checkedCount === allApplicableOptions.value.length;
            isIndeterminate.value = checkedCount > 0 && checkedCount < allApplicableOptions.value.length;
            handlUpdateChange(checkedTool.value);
        };
        var handleCheckAllChange = function(val) {
            checkedTool.value = val ? Array.from(allApplicableOptions.value, function(param) {
                var value = param.value;
                return Number(value);
            }) : [];
            isIndeterminate.value = false;
            handlUpdateChange(checkedTool.value);
        };
        var handleAddTag = function(value, operationType) {
            handlUpdateChange(value);
            resource.value.dialogFormInfo.field = "tag_ids";
            if (operationType === "addLabel") {
                resource.value.dialogFormInfo.action = "add";
            } else if (operationType === "deLabel") {
                resource.value.dialogFormInfo.action = "del";
            } else {
                resource.value.dialogFormInfo.action = "tags";
            }
        };
        var handleUpdateRemark = function() {
            resource.value.dialogFormInfo.remark = remark.value;
        };
        watch(function() {
            return resource.value.visible;
        }, function(flag) {
            if (flag) {
                publicRadio.value = 1;
                statusRadio.value = 2;
                copyrightRadio.value = 1;
                checkedTool.value = [];
                checkAll.value = false;
                isIndeterminate.value = false;
                tagConfig.treeParams.asset_type = resource.value.activeTab;
                tagConfig.isRefresh = true;
                audit_status.value = "approved";
                remark.value = "";
                // 清空默认选中
                if (tagCascaderRef.value) {
                    // @ts-ignore
                    tagCascaderRef.value.cascaderRef.$refs.panel.clearCheckedNodes();
                    // @ts-ignore
                    tagCascaderRef.value.$children[0].$refs.panel.activePath = [];
                }
            } else {
                tagConfig.isRefresh = false;
            }
        }, {
            immediate: true,
            deep: true
        });
        return {
            tagTitle: tagTitle,
            tagCascaderRef: tagCascaderRef,
            publicOptions: publicOptions,
            showStatusOptions: showStatusOptions,
            copyrightOptions: copyrightOptions,
            applicableOptions: applicableOptions,
            publicRadio: publicRadio,
            statusRadio: statusRadio,
            copyrightRadio: copyrightRadio,
            checkedTool: checkedTool,
            isIndeterminate: isIndeterminate,
            checkAll: checkAll,
            tagConfig: tagConfig,
            audit_status: audit_status,
            remark: remark,
            allApplicableOptions: allApplicableOptions,
            handleAddTag: handleAddTag,
            handleCheckedToolChange: handleCheckedToolChange,
            handleCheckAllChange: handleCheckAllChange,
            handlUpdateChange: handlUpdateChange,
            handleUpdateRemark: handleUpdateRemark
        };
    }
});
